import Revenue from './Revenue';
import Cashier from './cashier';
import Home from './home';
import Orders from './orders';
import Routes from './routes';
import Statistics from './trips/Statistics';
import Route from './trips/Route';
import Trips from './trips';
import PaymentSetting from './settings/payment/paymentSetting';
import UserSetting from './settings/user/userSetting';
import AccountSetting from './settings/account/accountSetting';
import BusOrder from './order/index';
import CustomerSetting from './settings/customer';
import BookingStatistics from './booking_statistics';
import SeatMap from './seat-map';
import Vehicles from './vehicles';
import BusOrderReport from './order/bookingReport';
import PassengerByRoute from './trips/passengerRoute';

export const routes = [
  {
    path: 'home',
    component: Home,
    permission: null,
  },

  {
    path: 'Revenue',
    component: Revenue,
    permission: null,
  },

  {
    path: 'booking',
    component: BusOrder,
    permission: null,
  },

  {
    path: 'cashier',
    component: Cashier,
    permission: null,
  },

  {
    path: 'route',
    component: Routes,
    permission: null,
  },
  {
    path: 'trips/Statistics',
    component: Statistics,
    permission: null,
  },
  {
    path: 'trips/routes',
    component: Route,
    permission: null,
  },
  {
    path: 'trips',
    component: Trips,
    permission: null,
  },
  {
    path: 'seatmap',
    component: SeatMap,
    permission: null,
  },
  {
    path: 'vehicles',
    component: Vehicles,
    permission: null,
  },
  //report
  {
    path: 'report/booking',
    component: Orders,
    permission: null,
  },
  {
    path: 'report/booking_statistics',
    component: BusOrderReport,
    permission: null,
  },
  {
    path: 'report/sales',
    component: Cashier,
    permission: null,
  },
  {
    path: 'report/trips',
    component: Trips,
    permission: null,
  },

  {
    path: 'passenger-route/:id',
    component: PassengerByRoute,
    permission: null,
  },

  //settings
  {
    path: 'settings/payment',
    component: PaymentSetting,
    permission: null,
  },
  {
    path: 'settings/account',
    component: AccountSetting,
    permission: null,
  },
  {
    path: 'settings/user',
    component: UserSetting,
    permission: null,
  },
  {
    path: 'settings/depart',
    component: Routes,
    permission: null,
  },
  {
    path: 'customer',
    component: CustomerSetting,
    permission: null,
  },
];
